(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy"]) return;
  try {
    
  (function(){
    var saved = null;
    try{ saved = localStorage.getItem('theme'); }catch(e){}
    document.documentElement.setAttribute('data-theme', saved === 'dark' ? 'dark' : 'light');
  })();

  var themeBtn = document.getElementById('themeToggle');
  var root = document.documentElement;
  themeBtn.setAttribute('aria-pressed', root.getAttribute('data-theme') === 'dark' ? 'true' : 'false');
  themeBtn.addEventListener('click', function(){
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try{ localStorage.setItem('theme', next); }catch(e){}
    themeBtn.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sourceo-landing"] && !Shopify.designMode) return;
  try {
    

  (function(){
    var saved = null;
    try{ saved = localStorage.getItem('theme'); }catch(e){}
    document.documentElement.setAttribute('data-theme', saved === 'dark' ? 'dark' : 'light');
  })();

  var themeBtn = document.getElementById('themeToggle');
  var root = document.documentElement;
  themeBtn.setAttribute('aria-pressed', root.getAttribute('data-theme') === 'dark' ? 'true' : 'false');
  themeBtn.addEventListener('click', function(){
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try{ localStorage.setItem('theme', next); }catch(e){}
    themeBtn.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
  });

  function initSlider(rootSelector, slideSelector, prevSelector, nextSelector, intervalMs){
    var root = document.querySelector(rootSelector);
    if (!root) return;
    var slides = root.querySelectorAll(slideSelector);
    if (slides.length <= 1) return;
    var current = 0;
    var timer = null;
    function show(i){
      slides[current].classList.remove('is-active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }
    function restart(){
      if (timer) clearInterval(timer);
      timer = setInterval(function(){ show(current + 1); }, intervalMs);
    }
    var prevBtn = root.querySelector(prevSelector);
    var nextBtn = root.querySelector(nextSelector);
    if (prevBtn) prevBtn.addEventListener('click', function(){ show(current - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ show(current + 1); restart(); });
    restart();
  }
  initSlider('.topstrip', '.topstrip-slide', '.topstrip-prev', '.topstrip-next', 5000);
  initSlider('.avis-slider', '.avis-slide', '.avis-prev', '.avis-next', 6000);

  (function(){
    var btn = document.getElementById('backToTop');
    if (!btn) return;
    function toggle(){
      if (window.scrollY > 600) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    }
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
    btn.addEventListener('click', function(){
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  var navBtn = document.getElementById('navToggle');
  var mobileNav = document.getElementById('mobileNav');
  navBtn.addEventListener('click', function(){
    var open = mobileNav.classList.toggle('open');
    navBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  mobileNav.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', function(){
      mobileNav.classList.remove('open');
      navBtn.setAttribute('aria-expanded', 'false');
    });
  });

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* ---------- I18N (FR / EN / ES) ---------- */
  var translations = {
    fr: {
      topstrip_1:"Offre de lancement : -31% aujourd'hui",
      topstrip_2:"Paiement 100% sécurisé",
      topstrip_3:"Téléchargement immédiat après achat",
      nav_guide:"Le guide", nav_bonus:"Bonus", nav_avis:"Avis", nav_faq:"FAQ", nav_cta:"Obtenir le guide",
      hero_h1:"Sourcer en Chine <em>sans se faire avoir</em>",
      hero_sub:"La méthode, les scripts de négociation avec un fournisseur chinois et les points de contrôle qui séparent une commande réussie d'un virement perdu dans le vide. Ce n'est pas de la théorie : tout part de là-bas, et ça se maîtrise.",
      hero_note:"<em>Sourcer</em>, c'est trouver et faire produire un article directement chez un fabricant, sans payer la marge de plusieurs intermédiaires au passage.",
      price_pct:"-31% aujourd'hui",
      hero_china_label:"CHINE — DÉPART", hero_flag_emoji:"🇫🇷", hero_flag_label:"FRANCE", hero_city_label:"VOTRE VILLE",
      stat1:"erreurs qui coûtent le plus cher", stat2:"agents de sourcing comparés", stat3:"étapes avant de sourcer", stat4:"Incoterms décryptés",
      trust1:"Sourcing testé sur Alibaba.com &amp; 1688.com", trust2:"Contenu basé sur des voyages réels en Chine", trust3:"Méthodologie Incoterms ICC expliquée simplement", trust4:"Paiement et téléchargement sécurisés, instantanés",
      prob_h2:"Les erreurs qui reviennent à chaque fois",
      prob1_h3:"Un intermédiaire déguisé en usine", prob1_p:"Des comptes qui affichent des photos d'usine ne sont parfois que des revendeurs avec une marge cachée. Le guide donne la question qui les démasque en un échange.",
      prob2_h3:"Le sample n'est pas la production", prob2_p:"Fabriqué à la main, avec un soin que 2000 pièces en série n'auront jamais. L'écart qualité se cadre par écrit, avant la commande.",
      prob3_h3:"Un devis flou sur qui paie quoi", prob3_p:"Transport, assurance, douane : sur un devis mal cadré, chaque poste peut basculer sur vous sans prévenir. Une seule question, réglée au Chapitre 6, referme ce piège.",
      terrain_h2:"Foshan, Shenzhen, Guangzhou : c'est de là que tout part",
      route_shop:"VOTRE BOUTIQUE", route_caption:"Le guide ne parle pas de villes au hasard : c'est le circuit réellement parcouru pour sourcer, négocier et contrôler la production sur place.",
      quote_text:"« Ne négocions jamais par crainte. Mais n'ayons jamais peur de négocier. »", quote_cite:"John F. Kennedy, discours d'investiture, 1961",
      chapters_h2:"9 chapitres, dans l'ordre où vous en avez besoin",
      th_n:"N°", th_ch:"Chapitre", th_take:"Ce que vous en tirez",
      ch01_t:"Les 5 erreurs qui coûtent le plus cher", ch01_p:"Repérer un intermédiaire déguisé, cadrer le sample, éviter le paiement sans recours.",
      ch02_t:"La méthode en 7 étapes", ch02_p:"De la niche précise au contrôle qualité, avant même de parler à un fournisseur.",
      ch03_t:"Où chercher, et avec qui", ch03_p:"1688, Alibaba, Foire de Canton, et 6 agents de sourcing comparés.",
      ch04_t:"Vérifier un fournisseur", ch04_p:"3 filtres qui éliminent la majorité des comptes à risque.",
      ch05_t:"Négocier comme un pro", ch05_p:"BATNA, leviers de volume, concessions conditionnelles, avec dialogues réels.",
      ch06_t:"Décrypter le devis", ch06_p:"EXW / DAP / DPU / DDP expliqués, et la question à copier-coller.",
      ch07_t:"Le contrôle qualité pré-expédition", ch07_p:"Ce que ça coûte, ce que ça évite, et pourquoi 9 débutants sur 10 le sautent à tort.",
      ch08_t:"Étude de cas appliquée", ch08_p:"Un produit à marge concrète, chapitre par chapitre, de la niche au contrôle qualité.",
      ch09_t:"Boîte à outils", ch09_p:"Check-list 10 points + 3 modèles de messages fournisseurs prêts à adapter.",
      lock_badge:"+ 5 chapitres débloqués avec le guide complet", lock_btn:"Tout débloquer — 27€",
      extract_h2:"Ce que vous lisez réellement dans le guide", extract_pill:"Extrait du Chapitre 6", extract_h3:"La fiche Incoterms",
      exw_p:"Vous gérez quasiment tout dès la sortie usine.", dap_p:"Livré au lieu convenu : à clarifier qui paie les taxes.", dpu_p:"Livré ET déchargé : à clarifier les conditions de déchargement.", ddp_p:"Le fournisseur prend en charge le maximum, taxes incluses.",
      copy_block:"Pour le devis, peux-tu préciser l'Incoterm (EXW / DAP / DPU / DDP) et détailler clairement :\n- transport inclus ou non\n- assurance incluse ou non\n- qui gère la douane export/import\n- qui paie droits et taxes\n- délai estimé + numéro de suivi",
      bonus_badge:"Bonus inclus", bonus_h3:"Ce qu'on ne met pas dans un ebook classique",
      bonus_li1:"<strong>Une sélection de fournisseurs et d'usines vérifiés</strong>, extraite d'une base de plus de 1000 contacts déjà validés : pas besoin de repartir de zéro sur la présélection.",
      bonus_li2:"<strong>Le contact d'agents de sourcing déjà identifiés</strong>, pour ceux qui préfèrent passer par un intermédiaire plutôt que négocier seuls avec l'usine.",
      bonus_li3:"<strong>Le contact direct d'un transitaire de confiance</strong> pour organiser le transport de votre première commande.",
      avis_h2:"Avis", avis_p:"Vous avez lu le guide ? <a href=\"mailto:sourceo-ebook@outlook.fr?subject=Mon%20avis%20sur%20le%20guide\">Partagez votre avis</a>.",
      avis_1:"« Je partais de zéro sur le sourcing. Maintenant je sais quoi vérifier avant même de contacter un fournisseur. »",
      avis_2:"« La partie sur les fournisseurs et la négociation m'a évité pas mal d'erreurs que j'aurais clairement faites seul. »",
      avis_3:"« Court, concret et surtout applicable. La checklist et les messages à envoyer aux fournisseurs font vraiment la différence. »",
      honesty_h3:"Ce qui ne change pas",
      honesty_p1:"<strong>Les méthodes de négociation et la fiche Incoterms sont des repères durables</strong> : ce ne sont pas des astuces qui périment d'une saison à l'autre.",
      honesty_p2:"La liste d'agents de sourcing, elle, peut évoluer : vérifiez toujours les conditions en cours avant d'engager un montant important. L'extrait plus haut sur cette page montre le contenu réel du guide, pas une promesse vague.",
      offer_h2:"Un guide, un prix, pas de frais cachés", offer_h3:"Guide complet — 9 chapitres + bonus",
      offer_li1:"PDF téléchargeable, lecture ~50 minutes", offer_li2:"Sélection de fournisseurs, usines et agents vérifiés + contact transitaire", offer_li3:"Check-list de préparation + 3 modèles de messages fournisseurs", offer_li4:"Fiche Incoterms + question de devis à copier-coller",
      cover_title:"Sourcer en Chine<br><em>sans se faire avoir</em>", cover_fmt:"Guide PDF · 9 chapitres",
      price_note:"Paiement unique — pas d'abonnement", instant:"Téléchargement instantané après paiement",
      secure_payment:"Paiement 100% sécurisé",
      btn_addcart:"Ajouter au panier", btn_buynow:"Acheter maintenant",
      promo_summary:"Vous avez un code promo ?", promo_placeholder:"Code promo", promo_btn:"Appliquer",
      faq_h2:"Questions avant d'acheter",
      faq1_q:"C'est un PDF ou un accès en ligne ?", faq1_a:"Un PDF téléchargeable, envoyé immédiatement après l'achat. Aucune plateforme à part, aucun compte à créer pour le lire.",
      faq2_q:"Je n'ai jamais sourcé de produit, c'est trop technique pour moi ?", faq2_a:"Non, le guide part du principe que vous n'avez jamais parlé à un fournisseur. Le Chapitre 2 couvre même comment trouver un produit avant de penser au sourcing.",
      faq3_q:"Et si je n'ai pas encore choisi de produit ?", faq3_a:"Le Chapitre 2 (méthode en 7 étapes) et le Chapitre 8 (étude de cas) sont justement construits pour ce cas : repérer un produit avant de chercher un fournisseur, pas l'inverse.",
      faq4_q:"Le guide est-il remboursable ?", faq4_a:"C'est un contenu numérique livré instantanément dès le paiement validé, ce qui exclut le droit de rétractation classique une fois le téléchargement effectué. L'extrait visible plus haut sur cette page sert justement à juger du contenu avant d'acheter.",
      faq5_q:"Quel est l'avantage de ce guide par rapport à des vidéos gratuites sur internet ?", faq5_a:"Le contenu gratuit est éparpillé et souvent générique. Ce guide condense une méthode complète, des contacts déjà vérifiés et des modèles prêts à l'emploi : le temps gagné à ne pas tout retrouver soi-même vaut largement le prix du guide.",
      faq6_q:"Puis-je démarrer avec un petit budget ?", faq6_a:"Oui : la plupart des fournisseurs et agents mentionnés dans le guide n'exigent pas de minimum de commande élevé. Vous pouvez démarrer avec un budget modeste et augmenter vos commandes progressivement.",
      faq7_q:"Ce guide convient-il si je fais du dropshipping, pas de l'import classique ?", faq7_a:"Oui : la méthode et les points de vérification s'appliquent aux deux. Que vous importiez du stock ou travailliez en direct avec un agent, les mêmes risques (intermédiaire déguisé, devis flou) existent des deux côtés.",
      faq_more_title:"Une autre question ?", faq_more_sub:"N'hésitez pas à nous contacter !", faq_more_btn:"Contactez-nous",
      footer_copy:"© 2026 Sourceo. Contenu indépendant, non affilié à Alibaba, 1688 ou aux agents de sourcing mentionnés dans le guide.",
      foot_legal:"Mentions légales", foot_cgv:"CGV", foot_refund:"Politique de remboursement", foot_privacy:"Politique de confidentialité", foot_shipping:"Politique d'expédition", foot_contact:"Contact",
      cart_title:"Votre panier", cart_empty:"Votre panier est vide", cart_continue:"Continuer les achats",
      cart_col_product:"Produit", cart_col_total:"Total", cart_estimated_total:"Total estimé", cart_checkout:"Passer la commande"
    },
    en: {
      topstrip_1:"Launch offer: -31% today",
      topstrip_2:"100% secure payment",
      topstrip_3:"Instant download after purchase",
      nav_guide:"The guide", nav_bonus:"Bonus", nav_avis:"Reviews", nav_faq:"FAQ", nav_cta:"Get the guide",
      hero_h1:"Sourcing from China <em>without getting scammed</em>",
      hero_sub:"The method, the negotiation scripts to use with a Chinese supplier, and the checkpoints that separate a successful order from a wire transfer lost in the void. This isn't theory: it all starts over there, and it can be mastered.",
      hero_note:"<em>Sourcing</em> means finding and manufacturing a product directly with a factory, without paying the margin of several middlemen along the way.",
      price_pct:"-31% today",
      hero_china_label:"CHINA — ORIGIN", hero_flag_emoji:"🌍", hero_flag_label:"YOUR COUNTRY", hero_city_label:"YOUR CITY",
      stat1:"most costly mistakes", stat2:"sourcing agents compared", stat3:"steps before sourcing", stat4:"Incoterms decoded",
      trust1:"Sourcing tested on Alibaba.com &amp; 1688.com", trust2:"Content based on real trips to China", trust3:"ICC Incoterms explained simply", trust4:"Secure, instant payment and download",
      prob_h2:"The mistakes that come up every time",
      prob1_h3:"A middleman disguised as a factory", prob1_p:"Accounts showing factory photos are sometimes just resellers with a hidden markup. The guide gives the one question that exposes them.",
      prob2_h3:"The sample isn't the production run", prob2_p:"Handmade, with a level of care 2,000 mass-produced units will never get. The quality gap needs to be framed in writing, before the order.",
      prob3_h3:"A quote that's vague about who pays what", prob3_p:"Shipping, insurance, customs: on a poorly framed quote, any of these costs can silently land on you. One single question, covered in Chapter 6, closes that trap.",
      terrain_h2:"Foshan, Shenzhen, Guangzhou: that's where it all starts",
      route_shop:"YOUR STORE", route_caption:"The guide doesn't mention cities at random: it's the actual circuit used to source, negotiate, and inspect production on site.",
      quote_text:"\"Let us never negotiate out of fear. But let us never fear to negotiate.\"", quote_cite:"John F. Kennedy, Inaugural Address, 1961",
      chapters_h2:"9 chapters, in the order you need them",
      th_n:"No.", th_ch:"Chapter", th_take:"What you get from it",
      ch01_t:"The 5 mistakes that cost the most", ch01_p:"Spot a disguised middleman, frame the sample properly, avoid payment with no recourse.",
      ch02_t:"The 7-step method", ch02_p:"From a precise niche to quality control, before even talking to a supplier.",
      ch03_t:"Where to look, and with whom", ch03_p:"1688, Alibaba, the Canton Fair, and 6 sourcing agents compared.",
      ch04_t:"Vetting a supplier", ch04_p:"3 filters that eliminate most risky accounts.",
      ch05_t:"Negotiating like a pro", ch05_p:"BATNA, volume leverage, conditional concessions, with real dialogue examples.",
      ch06_t:"Decoding the quote", ch06_p:"EXW / DAP / DPU / DDP explained, plus the question to copy-paste.",
      ch07_t:"Pre-shipment quality control", ch07_p:"What it costs, what it prevents, and why 9 out of 10 beginners wrongly skip it.",
      ch08_t:"Applied case study", ch08_p:"A real-margin product, chapter by chapter, from niche to quality control.",
      ch09_t:"Toolbox", ch09_p:"10-point checklist + 3 ready-to-adapt supplier message templates.",
      lock_badge:"+ 5 chapters unlocked with the full guide", lock_btn:"Unlock everything — €27",
      extract_h2:"What you actually read in the guide", extract_pill:"Excerpt from Chapter 6", extract_h3:"The Incoterms sheet",
      exw_p:"You handle almost everything from the factory gate.", dap_p:"Delivered to the agreed place: clarify who pays the taxes.", dpu_p:"Delivered AND unloaded: clarify the unloading conditions.", ddp_p:"The supplier covers the most, taxes included.",
      copy_block:"For the quote, can you specify the Incoterm (EXW / DAP / DPU / DDP) and clearly detail:\n- shipping included or not\n- insurance included or not\n- who handles export/import customs\n- who pays duties and taxes\n- estimated timeline + tracking number",
      bonus_badge:"Bonus included", bonus_h3:"What you won't find in a typical ebook",
      bonus_li1:"<strong>A selection of verified suppliers and factories</strong>, pulled from a database of over 1,000 already-vetted contacts: no need to start the shortlisting from scratch.",
      bonus_li2:"<strong>Contact details for already-identified sourcing agents</strong>, for those who'd rather go through an intermediary than negotiate directly with the factory.",
      bonus_li3:"<strong>Direct contact for a trusted freight forwarder</strong> to organize the shipping of your first order.",
      avis_h2:"Reviews", avis_p:"Read the guide? <a href=\"mailto:sourceo-ebook@outlook.fr?subject=My%20review\">Share your review</a>.",
      avis_1:"“I finally understand what to ask a supplier before placing an order. Straight to the point and genuinely useful.”",
      avis_2:"“The supplier verification section alone gave me a much clearer idea of what red flags to look for.”",
      avis_3:"“I had a product idea but no clue how to actually source it from China. This gave me a clear process to follow.”",
      honesty_h3:"What doesn't change",
      honesty_p1:"<strong>The negotiation methods and the Incoterms sheet are lasting references</strong>: they're not tricks that go stale from one season to the next.",
      honesty_p2:"The list of sourcing agents, on the other hand, can change over time: always check current terms before committing a large amount. The excerpt higher up this page shows the guide's actual content, not a vague promise.",
      offer_h2:"One guide, one price, no hidden fees", offer_h3:"Complete guide — 9 chapters + bonus",
      offer_li1:"Downloadable PDF, ~50 minute read", offer_li2:"Selection of verified suppliers, factories and agents + freight forwarder contact", offer_li3:"Preparation checklist + 3 supplier message templates", offer_li4:"Incoterms sheet + copy-paste quote question",
      cover_title:"Sourcing from China<br><em>without getting scammed</em>", cover_fmt:"PDF Guide · 9 chapters",
      price_note:"One-time payment — no subscription", instant:"Instant download after payment",
      secure_payment:"100% secure payment",
      btn_addcart:"Add to cart", btn_buynow:"Buy now",
      promo_summary:"Have a promo code?", promo_placeholder:"Promo code", promo_btn:"Apply",
      faq_h2:"Questions before you buy",
      faq1_q:"Is it a PDF or online access?", faq1_a:"A downloadable PDF, sent immediately after purchase. No separate platform, no account needed to read it.",
      faq2_q:"I've never sourced a product before, is this too technical for me?", faq2_a:"No, the guide assumes you've never spoken to a supplier before. Chapter 2 even covers how to find a product before thinking about sourcing.",
      faq3_q:"What if I haven't chosen a product yet?", faq3_a:"Chapter 2 (7-step method) and Chapter 8 (case study) are built exactly for this case: spotting a product before looking for a supplier, not the other way around.",
      faq4_q:"Is the guide refundable?", faq4_a:"It's digital content delivered instantly once payment is confirmed, which excludes the standard right of withdrawal once the download has happened. The excerpt visible higher up this page is there precisely so you can judge the content before buying.",
      faq5_q:"What's the advantage of this guide over free videos online?", faq5_a:"Free content is scattered and often generic. This guide condenses a complete method, already-vetted contacts, and ready-to-use templates: the time saved from not having to piece it all together yourself is worth far more than the price.",
      faq6_q:"Can I start with a small budget?", faq6_a:"Yes: most suppliers and agents mentioned in the guide don't require a high minimum order. You can start with a modest budget and scale your orders up over time.",
      faq7_q:"Does this guide work if I do dropshipping, not classic importing?", faq7_a:"Yes: the method and the verification points apply to both. Whether you import stock or work directly with an agent, the same risks (a disguised middleman, a vague quote) exist on both sides.",
      faq_more_title:"Another question?", faq_more_sub:"Don't hesitate to reach out!", faq_more_btn:"Contact us",
      footer_copy:"© 2026 Sourceo. Independent content, not affiliated with Alibaba, 1688, or the sourcing agents mentioned in the guide.",
      foot_legal:"Legal notice", foot_cgv:"Terms of sale", foot_refund:"Refund policy", foot_privacy:"Privacy policy", foot_shipping:"Shipping policy", foot_contact:"Contact",
      cart_title:"Your cart", cart_empty:"Your cart is empty", cart_continue:"Continue shopping",
      cart_col_product:"Product", cart_col_total:"Total", cart_estimated_total:"Estimated total", cart_checkout:"Check out"
    },
    es: {
      topstrip_1:"Oferta de lanzamiento: -31% hoy",
      topstrip_2:"Pago 100% seguro",
      topstrip_3:"Descarga inmediata tras la compra",
      nav_guide:"La guía", nav_bonus:"Bono", nav_avis:"Opiniones", nav_faq:"FAQ", nav_cta:"Obtener la guía",
      hero_h1:"Sourcing en China <em>sin que te la jueguen</em>",
      hero_sub:"El método, los guiones de negociación con un proveedor chino y los puntos de control que separan un pedido exitoso de una transferencia perdida en el vacío. Esto no es teoría: todo empieza allí, y se puede dominar.",
      hero_note:"Hacer <em>sourcing</em> es encontrar y fabricar un producto directamente con un fabricante, sin pagar el margen de varios intermediarios en el camino.",
      price_pct:"-31% hoy",
      hero_china_label:"CHINA — ORIGEN", hero_flag_emoji:"🌍", hero_flag_label:"TU PAÍS", hero_city_label:"TU CIUDAD",
      stat1:"errores que más cuestan", stat2:"agentes de sourcing comparados", stat3:"pasos antes de hacer sourcing", stat4:"Incoterms explicados",
      trust1:"Sourcing probado en Alibaba.com y 1688.com", trust2:"Contenido basado en viajes reales a China", trust3:"Incoterms ICC explicados de forma sencilla", trust4:"Pago y descarga seguros e instantáneos",
      prob_h2:"Los errores que se repiten siempre",
      prob1_h3:"Un intermediario disfrazado de fábrica", prob1_p:"Algunas cuentas que muestran fotos de fábrica son en realidad revendedores con un margen oculto. La guía da la pregunta que los desenmascara.",
      prob2_h3:"La muestra no es la producción", prob2_p:"Hecha a mano, con un cuidado que 2000 piezas en serie nunca tendrán. La diferencia de calidad se debe fijar por escrito antes del pedido.",
      prob3_h3:"Un presupuesto poco claro sobre quién paga qué", prob3_p:"Transporte, seguro, aduana: en un presupuesto mal definido, cualquier partida puede recaer sobre ti sin previo aviso. Una sola pregunta, tratada en el Capítulo 6, cierra esa trampa.",
      terrain_h2:"Foshan, Shenzhen, Guangzhou: de ahí parte todo",
      route_shop:"TU TIENDA", route_caption:"La guía no menciona ciudades al azar: es el circuito realmente recorrido para hacer sourcing, negociar y controlar la producción in situ.",
      quote_text:"«Nunca negociemos por miedo. Pero nunca tengamos miedo de negociar.»", quote_cite:"John F. Kennedy, discurso inaugural, 1961",
      chapters_h2:"9 capítulos, en el orden en que los necesitas",
      th_n:"N.º", th_ch:"Capítulo", th_take:"Qué obtienes",
      ch01_t:"Los 5 errores que más cuestan", ch01_p:"Detectar un intermediario disfrazado, definir bien la muestra, evitar pagos sin recurso.",
      ch02_t:"El método en 7 pasos", ch02_p:"De un nicho preciso al control de calidad, antes incluso de hablar con un proveedor.",
      ch03_t:"Dónde buscar y con quién", ch03_p:"1688, Alibaba, la Feria de Cantón, y 6 agentes de sourcing comparados.",
      ch04_t:"Verificar a un proveedor", ch04_p:"3 filtros que eliminan a la mayoría de las cuentas de riesgo.",
      ch05_t:"Negociar como un profesional", ch05_p:"BATNA, palancas de volumen, concesiones condicionales, con diálogos reales.",
      ch06_t:"Descifrar el presupuesto", ch06_p:"EXW / DAP / DPU / DDP explicados, y la pregunta para copiar y pegar.",
      ch07_t:"El control de calidad antes del envío", ch07_p:"Lo que cuesta, lo que evita, y por qué 9 de cada 10 principiantes se lo saltan por error.",
      ch08_t:"Estudio de caso aplicado", ch08_p:"Un producto con margen real, capítulo a capítulo, del nicho al control de calidad.",
      ch09_t:"Caja de herramientas", ch09_p:"Lista de verificación de 10 puntos + 3 plantillas de mensajes para proveedores.",
      lock_badge:"+ 5 capítulos desbloqueados con la guía completa", lock_btn:"Desbloquéalo todo — 27€",
      extract_h2:"Lo que realmente lees en la guía", extract_pill:"Extracto del Capítulo 6", extract_h3:"La ficha de Incoterms",
      exw_p:"Tú gestionas casi todo desde la salida de fábrica.", dap_p:"Entregado en el lugar acordado: aclarar quién paga los impuestos.", dpu_p:"Entregado Y descargado: aclarar las condiciones de descarga.", ddp_p:"El proveedor se hace cargo de casi todo, impuestos incluidos.",
      copy_block:"Para el presupuesto, ¿puedes indicar el Incoterm (EXW / DAP / DPU / DDP) y detallar claramente:\n- transporte incluido o no\n- seguro incluido o no\n- quién gestiona la aduana de exportación/importación\n- quién paga los aranceles e impuestos\n- plazo estimado + número de seguimiento",
      bonus_badge:"Bono incluido", bonus_h3:"Lo que no se incluye en un ebook clásico",
      bonus_li1:"<strong>Una selección de proveedores y fábricas verificados</strong>, extraída de una base de más de 1000 contactos ya validados: no hace falta partir de cero en la preselección.",
      bonus_li2:"<strong>El contacto de agentes de sourcing ya identificados</strong>, para quienes prefieren pasar por un intermediario en lugar de negociar solos con la fábrica.",
      bonus_li3:"<strong>El contacto directo de un transitario de confianza</strong> para organizar el transporte de tu primer pedido.",
      avis_h2:"Opiniones", avis_p:"¿Ya leíste la guía? <a href=\"mailto:sourceo-ebook@outlook.fr?subject=Mi%20opinion\">Comparte tu opinión</a>.",
      avis_1:"“Lo que más me gustó es que explica el proceso sin complicarlo. Ahora sé por dónde empezar y qué evitar.”",
      avis_2:"“Antes comparaba proveedores casi solo por el precio. La guía me hizo prestar atención a cosas mucho más importantes.”",
      avis_3:"“Los ejemplos y las preguntas para los proveedores hacen que todo sea mucho más práctico. No se queda solo en teoría.”",
      honesty_h3:"Lo que no cambia",
      honesty_p1:"<strong>Los métodos de negociación y la ficha de Incoterms son referencias duraderas</strong>: no son trucos que caduquen de una temporada a otra.",
      honesty_p2:"La lista de agentes de sourcing, en cambio, puede evolucionar: verifica siempre las condiciones vigentes antes de comprometer una cantidad importante. El extracto más arriba en esta página muestra el contenido real de la guía, no una promesa vaga.",
      offer_h2:"Una guía, un precio, sin costes ocultos", offer_h3:"Guía completa — 9 capítulos + bono",
      offer_li1:"PDF descargable, ~50 minutos de lectura", offer_li2:"Selección de proveedores, fábricas y agentes verificados + contacto de transitario", offer_li3:"Lista de preparación + 3 plantillas de mensajes para proveedores", offer_li4:"Ficha de Incoterms + pregunta de presupuesto para copiar y pegar",
      cover_title:"Sourcing en China<br><em>sin que te la jueguen</em>", cover_fmt:"Guía PDF · 9 capítulos",
      price_note:"Pago único — sin suscripción", instant:"Descarga instantánea tras el pago",
      secure_payment:"Pago 100% seguro",
      btn_addcart:"Añadir al carrito", btn_buynow:"Comprar ahora",
      promo_summary:"¿Tienes un código promocional?", promo_placeholder:"Código promocional", promo_btn:"Aplicar",
      faq_h2:"Preguntas antes de comprar",
      faq1_q:"¿Es un PDF o un acceso en línea?", faq1_a:"Un PDF descargable, enviado inmediatamente después de la compra. Sin plataforma aparte, sin necesidad de crear una cuenta para leerlo.",
      faq2_q:"Nunca he hecho sourcing de un producto, ¿es demasiado técnico para mí?", faq2_a:"No, la guía parte de la base de que nunca has hablado con un proveedor. El Capítulo 2 incluso explica cómo encontrar un producto antes de pensar en el sourcing.",
      faq3_q:"¿Y si todavía no he elegido un producto?", faq3_a:"El Capítulo 2 (método en 7 pasos) y el Capítulo 8 (estudio de caso) están pensados justo para este caso: detectar un producto antes de buscar un proveedor, no al revés.",
      faq4_q:"¿Es reembolsable la guía?", faq4_a:"Es un contenido digital que se entrega al instante tras confirmarse el pago, lo que excluye el derecho de desistimiento habitual una vez realizada la descarga. El extracto visible más arriba en esta página sirve justo para valorar el contenido antes de comprar.",
      faq5_q:"¿Cuál es la ventaja de esta guía frente a vídeos gratuitos en internet?", faq5_a:"El contenido gratuito está disperso y suele ser genérico. Esta guía condensa un método completo, contactos ya verificados y plantillas listas para usar: el tiempo que ahorras vale mucho más que el precio de la guía.",
      faq6_q:"¿Puedo empezar con un presupuesto pequeño?", faq6_a:"Sí: la mayoría de los proveedores y agentes mencionados en la guía no exigen un pedido mínimo elevado. Puedes empezar con un presupuesto modesto e ir aumentando tus pedidos poco a poco.",
      faq7_q:"¿Esta guía sirve si hago dropshipping y no importación clásica?", faq7_a:"Sí: el método y los puntos de verificación se aplican a ambos casos. Ya sea que importes stock o trabajes directamente con un agente, existen los mismos riesgos (intermediario disfrazado, presupuesto poco claro) en ambos lados.",
      faq_more_title:"¿Tienes otra pregunta?", faq_more_sub:"¡No dudes en contactarnos!", faq_more_btn:"Contáctanos",
      footer_copy:"© 2026 Sourceo. Contenido independiente, no afiliado a Alibaba, 1688 ni a los agentes de sourcing mencionados en la guía.",
      foot_legal:"Aviso legal", foot_cgv:"Condiciones de venta", foot_refund:"Política de reembolso", foot_privacy:"Política de privacidad", foot_shipping:"Política de envío", foot_contact:"Contacto",
      cart_title:"Tu carrito", cart_empty:"Tu carrito está vacío", cart_continue:"Seguir comprando",
      cart_col_product:"Producto", cart_col_total:"Total", cart_estimated_total:"Total estimado", cart_checkout:"Finalizar compra"
    }
  };

  function applyLang(lang){
    if (!translations[lang]) lang = 'fr';
    document.documentElement.lang = lang;
    document.querySelectorAll('[data-i18n]').forEach(function(el){
      var key = el.getAttribute('data-i18n');
      var t = translations[lang][key];
      if (t !== undefined) el.innerHTML = t;
    });
    document.querySelectorAll('[data-i18n-placeholder]').forEach(function(el){
      var key = el.getAttribute('data-i18n-placeholder');
      var t = translations[lang][key];
      if (t !== undefined) el.setAttribute('placeholder', t);
    });
    document.querySelectorAll('.lang-switch').forEach(function(sel){ sel.value = lang; });
    try{ localStorage.setItem('lang', lang); }catch(e){}
  }

  var savedLang = 'fr';
  try{ savedLang = localStorage.getItem('lang') || 'fr'; }catch(e){}
  applyLang(savedLang);

  document.querySelectorAll('.lang-switch').forEach(function(sel){
    sel.addEventListener('change', function(){ applyLang(sel.value); });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(){
      var current = document.documentElement.lang || 'fr';
      setTimeout(function(){ applyLang(current); });
    });
  }


  } catch(e) { console.error(e); }
})();
})();
